/* eslint-disable max-len */
import { LocationsModuleMessages, TranslationLocationsModuleMessages } from "../interfaces";

export const messages: TranslationLocationsModuleMessages = {

  /* region Frontend messages */
  [LocationsModuleMessages.name]: "Name",
  [LocationsModuleMessages.type]: "Type",
  [LocationsModuleMessages.address]: "Street",
  [LocationsModuleMessages.number]: "Number",
  [LocationsModuleMessages.district]: "District",
  [LocationsModuleMessages.county]: "City",
  [LocationsModuleMessages.state]: "State",
  [LocationsModuleMessages.zipCode]: "ZIP Code",
  [LocationsModuleMessages.regional]: "Regional",
  [LocationsModuleMessages.noNumber]: "No number",
  [LocationsModuleMessages.noNameRegistered]: "No name registered",
  [LocationsModuleMessages.dataTableTitle]: "locations",
  [LocationsModuleMessages.deleteConfirmationTitle]: "Deletion confirmation",
  [LocationsModuleMessages.deleteConfirmationText]: "Do you really want to delete the location",
  [LocationsModuleMessages.deactivateConfirmationTitle]: "Location cannot be deleted",
  [LocationsModuleMessages.deactivateConfirmationText]: "This location is already linked to history records and therefore cannot be "
    + "deleted. Do you want to deactivate it? It stops being taken into account by the rules and forms, and the history is preserved",
  [LocationsModuleMessages.deactivateLocationSuccess]: "Location deactivated successfully",
  [LocationsModuleMessages.searching]: "Searching locations...",
  [LocationsModuleMessages.formZipCodeIncomplete]: "Incomplete ZIP Code",
  [LocationsModuleMessages.formExternalIdAlreadyRegistered]: "External ID already registered",
  [LocationsModuleMessages.formTypeRequired]: "Type is required",
  [LocationsModuleMessages.formExternalIdRequired]: "External ID is required for a construction and cannot be changed later",
  [LocationsModuleMessages.formAddressRequired]: "Street is required",
  [LocationsModuleMessages.formDistrictRequired]: "District is required",
  [LocationsModuleMessages.formCountyRequired]: "City is required",
  [LocationsModuleMessages.formNameRequired]: "Name is required",
  [LocationsModuleMessages.formStateRequired]: "State is required",
  [LocationsModuleMessages.toastCoordsNotDefinedTitle]: "Coordinates not defined",
  [LocationsModuleMessages.toastCoordsNotDefinedDescription]: "Define the coordinates by setting them on the map or searching by ZIP Code",
  [LocationsModuleMessages.toastNoZipCodeDataFoundDescription]: "No data found for the ZIP Code",
  [LocationsModuleMessages.toastSelectLocationInMapDescription]: "Select a location on the map",
  [LocationsModuleMessages.toastDataLoadedDescription]: "Data loaded successfully!",
  [LocationsModuleMessages.toastLocationModifiedWithoutAddress]: "Location modified without address changes",
  [LocationsModuleMessages.updateConfirmationTitle]: "Confirmation to update address data",
  [LocationsModuleMessages.updateConfirmationText]: "Do you want to update the following location data?",
  [LocationsModuleMessages.detailsLocationRegisterTitle]: "Location registration",
  [LocationsModuleMessages.noNameRegistered]: "No name registered",
  [LocationsModuleMessages.detailsMapPosition]: "Map position",
  [LocationsModuleMessages.detailsEditLabel]: "Edit",
  [LocationsModuleMessages.externalId]: "External ID",
  [LocationsModuleMessages.detailsExternalIdHelper]: "Ref. to integrations",
  [LocationsModuleMessages.externalIdLockedOnConstruction]: "Not editable on a construction — it is the key used by the integration",
  [LocationsModuleMessages.integratedConstructionAddressHelper]: "Integration address — only adjust the location on the map",
  [LocationsModuleMessages.detailsType]: "Location type",
  [LocationsModuleMessages.detailsRadius]: "Fence (Radius)",
  [LocationsModuleMessages.detailsRadiusHelper]: "In meters (m)",
  [LocationsModuleMessages.searching]: "Searching...",
  [LocationsModuleMessages.detailsSearchZipCode]: "Search ZIP Code",
  [LocationsModuleMessages.complement]: "Complement",
  [LocationsModuleMessages.detailsAllowTravelClosure]: "Allows trip closure",
  [LocationsModuleMessages.mapButtonConfirmLocation]: "Confirm location",
  [LocationsModuleMessages.active]: "Active",
  [LocationsModuleMessages.inactive]: "Inactive",
  [LocationsModuleMessages.activeLocation]: "Active location",

  /* endregion Frontend messages */
  /* region Backend messages */
  [LocationsModuleMessages.getLocationDataByGoogleSuccess]: "Data returned successfully",
  [LocationsModuleMessages.getLocationDataByGoogleError]: "Error fetching location data",
  [LocationsModuleMessages.readLocationTypeSuccess]: "Location type(s) returned successfully",
  [LocationsModuleMessages.noLocationTypeFound]: "No location type found",
  [LocationsModuleMessages.readLocationTypeError]: "Error fetching location type(s)",
  [LocationsModuleMessages.createLocationSuccess]: "Location created successfully",
  [LocationsModuleMessages.readLocationSuccess]: "Location(s) returned successfully",
  [LocationsModuleMessages.updateLocationSuccess]: "Location updated successfully",
  [LocationsModuleMessages.deleteLocationSuccess]: "Location deleted successfully",
  [LocationsModuleMessages.getPlantsLocationsSuccess]: "Plants returned successfully",
  [LocationsModuleMessages.createLocationError]: "Error creating location",
  [LocationsModuleMessages.readLocationError]: "Error fetching location(s)",
  [LocationsModuleMessages.noLocationFound]: "No location found",
  [LocationsModuleMessages.locationNotFound]: "Location not found in our system",
  [LocationsModuleMessages.updateLocationError]: "Error updating location",
  [LocationsModuleMessages.deleteLocationError]: "Error deleting location",
  [LocationsModuleMessages.deleteLocationInUse]: "This location cannot be deleted because it is already linked to history records "
    + "(travels, events, states or alerts). Deactivate it so it is no longer taken into account, keeping the history intact",
  [LocationsModuleMessages.noPlantFound]: "No plant found",
  [LocationsModuleMessages.getPlantsLocationsError]: "Error fetching plants",
  [LocationsModuleMessages.externalID]: "External ID",
  [LocationsModuleMessages.createPlantSuccess]: "Plant created successfully",
  [LocationsModuleMessages.createPlantError]: "Error creating plant",
  [LocationsModuleMessages.updatePlantSuccess]: "Plant updated successfully",
  [LocationsModuleMessages.updatePlantError]: "Error updating plant",
  [LocationsModuleMessages.plantNotFound]: "Plant not found in our system",
  [LocationsModuleMessages.deletePlantSuccess]: "Plant deleted successfully",
  [LocationsModuleMessages.deletePlantError]: "Error deleting plant",

  /* region Integration messages */
  [LocationsModuleMessages.addressNotFound]: "Address(es) not found",
  [LocationsModuleMessages.externalIDAlreadyRegistered]: "External ID(s) already registered",
  [LocationsModuleMessages.needToInformLocationData]: "You must inform valid latitude and longitude or address information (county, uf, district, ...)",
  [LocationsModuleMessages.noAddressChanges]: "Location has not had address changes",
  [LocationsModuleMessages.locationLinkedToAVehicleState]: "Location linked to a vehicle state",
  /* endregion Integration messages */

  /* endregion Backend messages */
  /* region Location Types */
  [LocationsModuleMessages.plant]: "Plant",
  [LocationsModuleMessages.construction]: "Construction",
  [LocationsModuleMessages.autoElectricalWorkshop]: "Auto Electrical Workshop",
  [LocationsModuleMessages.tireRepairShop]: "Tire Repair Shop",
  [LocationsModuleMessages.gasStation]: "Gas Station",
  [LocationsModuleMessages.workshop]: "Workshop",
  [LocationsModuleMessages.parkingLot]: "Parking Lot",
  [LocationsModuleMessages.others]: "Others",
  [LocationsModuleMessages.supplier]: "Supplier",
  [LocationsModuleMessages.client]: "Client",
  /* endregion Location Types */

  /* region Construction consolidation */
  [LocationsModuleMessages.adjustConstruction]: "Adjust construction location",
  [LocationsModuleMessages.adjustConstructionTooltip]: "Adjust the construction location to this discharge point and automatically justify the alerts within the radius",
  [LocationsModuleMessages.adjustConstructionDischargePoint]: "Improper discharge",
  [LocationsModuleMessages.adjustConstructionShapeLabel]: "Define the construction by",
  [LocationsModuleMessages.adjustConstructionRadiusOption]: "Radius",
  [LocationsModuleMessages.adjustConstructionPolygonOption]: "Polygon",
  [LocationsModuleMessages.adjustConstructionRadiusHint]: "Adjust the construction area: drag the circle, resize the radius or draw a polygon. The red dot marks the improper discharge. On save, the pending alerts inside the area are automatically justified.",
  [LocationsModuleMessages.adjustConstructionPolygonHint]: "Draw the construction polygon on the map. On save, the construction is defined by the drawn area and the pending improper discharge alerts within the polygon are automatically justified.",
  [LocationsModuleMessages.adjustConstructionPolygonWarning]: "This construction has a registered polygon. Adjusting by the pin replaces the construction geometry: the polygon is removed and the area is defined by the radius. To use a polygon again, choose \"Polygon\" above and redraw the area.",
  [LocationsModuleMessages.adjustConstructionRadiusField]: "Radius (m)",
  [LocationsModuleMessages.adjustConstructionOptionalHelper]: "Optional — if empty, uses",
  [LocationsModuleMessages.adjustConstructionCurrentRadiusSuffix]: "m (current construction radius)",
  [LocationsModuleMessages.adjustConstructionDefaultRadiusSuffix]: "m (default)",
  [LocationsModuleMessages.adjustConstructionSave]: "Save adjustment",
  [LocationsModuleMessages.adjustConstructionDrawFirst]: "Draw the construction polygon on the map before saving.",
  [LocationsModuleMessages.adjustConstructionNotAConstruction]: "This location is not a construction. Only constructions can be adjusted and consolidated.",
  [LocationsModuleMessages.adjustConstructionSuccessPrefix]: "Location adjusted —",
  [LocationsModuleMessages.adjustConstructionAlertsJustified]: "alert(s) automatically justified",
  [LocationsModuleMessages.constructionConsolidatedChip]: "Consolidated",
  [LocationsModuleMessages.constructionConsolidatedTooltip]: "Location consolidated by the discharges — coordinates no longer follow the deliveries",
  [LocationsModuleMessages.locationNameFilter]: "Location name",
  [LocationsModuleMessages.viewConstructionTravels]: "Construction travels",
  [LocationsModuleMessages.constructionTravelsTitle]: "Travels of this construction",
  [LocationsModuleMessages.constructionTravelsEmpty]: "No travels found for this construction"
  /* endregion */
};
